import { render, staticRenderFns } from "./IntegrationsTable.vue?vue&type=template&id=aa8134fa&scoped=true"
import script from "./IntegrationsTable.vue?vue&type=script&lang=js"
export * from "./IntegrationsTable.vue?vue&type=script&lang=js"
import style0 from "./IntegrationsTable.vue?vue&type=style&index=0&id=aa8134fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8134fa",
  null
  
)

export default component.exports